/**
 * Created by intellicar-rinas on 4/10/17.
 */
import { schemaTypes, dateFormat } from "../../../constants/constants";
import ReportAPIs from "../../../APIs/ReportAPIs";
import GeoCodeAPIs from "../../../APIs/GeoCodeAPIs";
import { JSONToCSVConvertor } from "../../../helpers/helperFunctions";

let nameMapping = [
  { key: "airfilterclogcount", value: "Air Filter Clog Count [Alarm]" },
  { key: "enginecoolanttempcount", value: "Engine Coolant Temp Count [Alarm]" },
  { key: "engineoilpresscount", value: "Engine Oil Pressure Count [Alarm]" },
  { key: "estopcount", value: "E Stop Count [Alarm]" },
  { key: "lowrpmcount", value: "Low RPM Count [Alarm]" },
  { key: "parkbrakecount", value: "Parking Brake Count [Alarm]" },
  { key: "seatswithopencount", value: "Driver Not Seated [Alarm]" },

  { key: "distance", value: "Running Distance", unit: "Km" },
  {
    key: "travelwithoutvibration",
    value: "Travel Without Vibration",
    unit: "m",
  },
  { key: "fuelconsumed", value: "Fuel Consumed", unit: "Ltr" },

  { key: "batterychargingtime", value: "Battery Charging Time", unit: "min" },
  { key: "highvibrationtime", value: "High Vibration Time", unit: "min" },
  { key: "hourend", value: "Hour End", unit: "min" },
  { key: "hourstart", value: "Hour Start", unit: "min" },
  { key: "idletime", value: "Idle Time", unit: "min" },
  { key: "lowvibrationtime", value: "Low Vibration Time", unit: "min" },
  { key: "stoppagetime", value: "Stopppage Time", unit: "min" },
  { key: "totalhours", value: "Total Hours", unit: "min" },
  { key: "vibrationtimefwd", value: "Vibration Time Forward", unit: "min" },
  { key: "vibrationtimereverse", value: "Vibration Time Reverse", unit: "min" },
];

const processData = (respObj, vehicleMap, callback) => {
  let historyData = [];

  for (let idx in nameMapping) {
    if (!(nameMapping[idx].key in respObj)) continue;

    historyData.push({
      alarm: nameMapping[idx].value,
      count:
        respObj[nameMapping[idx].key] +
        (nameMapping[idx].unit ? " " + nameMapping[idx].unit : ""),
    });
  }

  callback(historyData);
};

const getHistory = (schema, data, store) => {
  schema.finalData = null;
  let saveState = null;
  let tableStateData = null;
  if (data.vehicle && data.vehicle.length) {
    if (window.setReportWindowTabBusy)
      window.setReportWindowTabBusy(schema, true);
    const handleSuccess = (resp) => {
      if (window.setReportWindowTabBusy)
        window.setReportWindowTabBusy(schema, false);
      processData(resp, store.vehicleMap, (data) => {
        schema.finalData = data;
        if (tableStateData && tableStateData[0]) {
          tableStateData[0].body = data;
          tableStateData[0].busy = false;
          saveState(tableStateData[0], tableStateData[1], tableStateData[2]);
        }
        if (schema.content[0].ref) {
          schema.content[0].ref.setData(data);
        }
      });
    };
    if (schema.content[0].ref) {
      schema.content[0].ref.setBusy(true);
      saveState = schema.content[0].ref.props.saveState;
      tableStateData = [
        schema.content[0].ref.state,
        schema.content[0].ref.props.schemaKey,
        schema.content[0].ref.props.data,
      ];
    }
    let body = {
      vehicleid: data.vehicle.map((item) => {
        return item.data.vehicleid;
      }),
      starttime: data.starttime.unix() * 1000,
      endtime: data.endtime.unix() * 1000,
    };
    if (window.showNoGpsFixData === true) {
      body.fixqfilter = false;
    }
    ReportAPIs.getVolvoCompactorMetrics(body).then(handleSuccess, (r) => {
      handleSuccess({});
    });
  } else {
    console.log("Please select atleast one vehicle");
  }
};

const schema = {
  key: "compactor_report",
  name: "Compactor Report",
  toolbar: [
    {
      key: "vehicle",
      type: schemaTypes.MULTI_SELECT,
      singleSelect: true,
      storeData: (state) => {
        return {
          data: (() => {
            let newMap = {};
            for (let idx in state.vehicleMap) {
              if (idx.indexOf("user") === -1) {
                newMap[idx] = state.vehicleMap[idx];
              }
            }
            return newMap;
          })(),
          name: "vehicleno",
          id: "vehicleid",
        };
      },
      onItemChange: (v) => window.saveVehicleState(v),
      defaultValue: () => {
        return {
          data: window.selectedVehicles.map((i) => {
            return i.id;
          }),
          updatedAt: window.selectedVehiclesUpdatedAt,
        };
      },
    },
    {
      key: "starttime",
      type: schemaTypes.DATE_PICKER,
      setIfNull: true,
      placeholder: "Start Date",
      model: Date.now() - 1000 * 60 * 60 * 24,
    },
    {
      key: "endtime",
      type: schemaTypes.DATE_PICKER,
      setIfNull: true,
      placeholder: "End Date",
    },
    {
      key: "get_history",
      type: schemaTypes.BUTTON,
      name: "Get Daily Report",
      onClick: getHistory,
    },
    {
      key: "download",
      type: schemaTypes.BUTTON,
      iconType: "class",
      icon: "fa fa-download",
      onClick: () => {
        if (schema.finalData) {
          JSONToCSVConvertor(schema.finalData, "ViewReport", false);
        }
      },
    },
  ],
  content: [
    {
      key: "dataTable",
      type: schemaTypes.IN_TABLE,
      position: {
        width: 12,
        height: 12,
        left: 0,
        top: 0,
      },
      head: [
        { key: "alarm", name: "Name" },
        { key: "count", name: "Count" },
      ],
    },
  ],
};

export default schema;
